import React from 'react';
import Layout from '@/components/layout/Layout';
import BenchmarkPerformanceReport from '@/components/reports/BenchmarkPerformanceReport';

const Report: React.FC = () => {
  return (
    <Layout fullWidth>
      <div className="h-full">
        <BenchmarkPerformanceReport />
      </div>
    </Layout>
  );
};

export default Report;